// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { SYSTEM } from '../internal/environment';
import customCssProps from '../internal/generated/custom-css-properties';
export function getDropdownStyles(style) {
    if (SYSTEM !== 'core' || !(style === null || style === void 0 ? void 0 : style.dropdown)) {
        return undefined;
    }
    return {
        background: style.dropdown.background,
        [customCssProps.dropdownContentBorderColor]: style.dropdown.borderColor,
        [customCssProps.dropdownContentBorderWidth]: style.dropdown.borderWidth,
        [customCssProps.dropdownContentBorderRadius]: style.dropdown.borderRadius,
    };
}
//# sourceMappingURL=style.js.map